import { useFormItemEnabled, type RelationEditor } from '@framework/form';
import { t } from '@framework/i18n';
import { Button } from 'antd';
import { useEffect, useRef } from 'react';
import { type IMultiPreferenceRow } from './createMultiPreferenceFormSchema';

export interface IMultiPreferenceWidgetButtonProps {
  editor: RelationEditor<IMultiPreferenceRow>;
  isMax: boolean;
  onReset?: () => void;
}
export function MultiPreferenceWidgetButton(
  props: IMultiPreferenceWidgetButtonProps,
) {
  const { editor, isMax, onReset } = props;
  const { enabled, layoutEnabled } = useFormItemEnabled();

  // Eliminiamo le preferenze in caso di disabilitazione del form
  const computedPreviousDisabledRef = useRef(
    enabled === false || layoutEnabled === false,
  );

  useEffect(() => {
    const computedDisabled = enabled === false || layoutEnabled === false;
    if (
      computedDisabled !== false &&
      computedPreviousDisabledRef.current === computedDisabled
    ) {
      return;
    }

    if (computedDisabled) {
      onReset?.();
    }

    computedPreviousDisabledRef.current = computedDisabled;
  }, [enabled, layoutEnabled, onReset]);

  return (
    <Button
      size="large"
      block
      disabled={isMax || enabled === false || layoutEnabled === false}
      onClick={() =>
        editor.append({
          // NOTE E' fondamentale che il campo id sia presente, anche se vuoto,
          // altrimenti il `transform` non viene applicato e non viene
          // generato il campo id.
          id: '', // Generato automaticamente
        })
      }
      type="primary"
    >
      {t('multi-preference-widget.add', {
        defaultValue: 'Aggiungi',
      })}
    </Button>
  );
}
